import { memo } from 'react';
import { RefreshListIcons } from '../../../../../../icons/icons';
import { Box, ButtonBase, Typography } from '@mui/material';

export interface RefreshButtonProps {
  onRefresh: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export const RefreshButton = memo<RefreshButtonProps>(
  ({ onRefresh, loading = false, disabled = false }) => (
    <ButtonBase
      onClick={onRefresh}
      disabled={disabled || loading}
      title={loading ? 'Refreshing data...' : 'Refresh chart data'}
      aria-label={loading ? 'Refreshing data...' : 'Refresh chart data'}
      sx={{
        height: 32,
        px: 1.25,
        borderRadius: '8px',
        transition: 'all 0.3s',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.75,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        ...(disabled || loading
          ? {
              bgcolor: 'transparent',
              color: '#cbd5e1',
              cursor: 'not-allowed',
              opacity: 0.4,
              pointerEvents: 'none',
            }
          : {
              bgcolor: 'transparent',
              color: '#475569',
              '&:hover': { bgcolor: 'rgba(241,245,249,0.8)' },
              '&:active': { bgcolor: 'rgba(226,232,240,0.5)' },
            }),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          transition: 'all 0.3s',
          ...(loading
            ? {
                animation: 'spin 1s linear infinite',
                '@keyframes spin': {
                  from: { transform: 'rotate(0deg)' },
                  to: { transform: 'rotate(360deg)' },
                },
              }
            : {}),
        }}
      >
        <RefreshListIcons size={14} color={loading ? '#9ca3af' : '#475569'} />
      </Box>
      <Typography
        component="span"
        sx={{
          display: { xs: 'none', lg: 'inline' },
          fontSize: '12px',
          fontWeight: 500,
        }}
      >
        {loading ? 'Refreshing...' : 'Refresh'}
      </Typography>
    </ButtonBase>
  ),
);

RefreshButton.displayName = 'RefreshButton';
